import { HTMLAttributes, useCallback, useRef } from 'react'
import { Image, ImageWrapper, StyledBase64Image } from './Styled'

export interface CoverImageProps extends HTMLAttributes<HTMLDivElement> {
  base64SrcSource?: any
  onBase64ImageLoad?: any
  source?: any
  src?: string | null
  objectFit?: 'contain' | 'auto'
}

const CoverImage = ({
  base64SrcSource,
  onBase64ImageLoad,
  source,
  src,
  // contain | auto
  objectFit = 'contain',
  ...props
}: CoverImageProps) => {
  const imageWrapperRef = useRef<HTMLDivElement>(null)
  /**
   * @type {import('react').EventHandler<import('react').SyntheticEvent<HTMLImageElement, Event>>} ev
   */
  const onLoad = (ev) => {
    if (objectFit === 'auto') {
      const { naturalWidth, naturalHeight } = ev.currentTarget
      if (naturalWidth >= naturalHeight) {
        ev.currentTarget.style.objectFit = 'contain'
      } else {
        ev.currentTarget.style.objectFit = 'cover'
      }
    }
  }
  const onBase64Load = useCallback(() => {
    if (objectFit !== 'auto') {
      return
    }
    const image = imageWrapperRef.current?.querySelector('img')
    if (!image) {
      return
    }
    if (image.naturalWidth >= image.naturalHeight) {
      image.style.objectFit = 'contain'
    } else {
      image.style.objectFit = 'cover'
    }
  }, [objectFit])
  return src ? (
    <ImageWrapper {...props} ref={imageWrapperRef}>
      <Image src={src} alt="" onLoad={onLoad} />
    </ImageWrapper>
  ) : (
    <ImageWrapper {...props} ref={imageWrapperRef}>
      <StyledBase64Image
        hidePlaceholderOnLoaded
        placeholder={''}
        source={source}
        onBase64ImageLoad={onBase64ImageLoad}
        noLazy={true}
        src={base64SrcSource}
        onLoad={onBase64Load}
      ></StyledBase64Image>
    </ImageWrapper>
  )
}

export default CoverImage
